// extracted by mini-css-extract-plugin
export default {"row":"editRMG_row__daKWz","col":"editRMG_col__KytMg","card":"editRMG_card__e8VJv"};